module.exports = __webpack_public_path__ + "static/media/20.1bf4d812.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/20.png
// module id = 387
// module chunks = 0